export const model = {
  make: "Make",
  modelName: "Model Name",
  driveTrainType: "Drive Train Type",
  driveTrainTypeEV: "EV",
  driveTrainTypeCombustion: "Combustion",
  vehicles: "Total Vehicles",
  inspectionTemplate: "Inspection Template",
  tireDimension: "Tire Dimension ({0})",
  tireDimensionNoUnit: "Tire Dimension",
};
